import { render, staticRenderFns } from "./dashboardCards.vue?vue&type=template&id=da36ebfe&"
import script from "./dashboardCards.vue?vue&type=script&lang=js&"
export * from "./dashboardCards.vue?vue&type=script&lang=js&"
import style0 from "./dashboardCards.vue?vue&type=style&index=0&id=da36ebfe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports